module.exports = __webpack_public_path__ + "media/assets/images/blog/customer_service_operator-small-bbc72eea44b483ed2cce0188f6802f92.jpeg";